import { NgModule, Component, Input, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'playlist-row',
    templateUrl: 'playlist-row.template.html',
    styleUrls: ['playlist-row.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaylistRow {
    @Input() item: any;
    @Input() content: any;
    @Input() layout: string = "container";

    protected playListLabel = "PLAYLIST";

    private config: any;
    private ready: boolean;
    private carouselConfig = {
        showCopy: false,
        viewSlides: 4,
        spacing: 5,
        style: 'playlist-carousel',
        center: false,
        showBack: false,
        dim: false,
        grow: false,
        showTags: false,
        clipTitle: true,        
    };

    constructor(
        private coreEffects: CoreEffects,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit() {
        if (this.router.url.indexOf("episodes/") > -1){
            this.playListLabel = "EPISODES";
        }
        if (!this.content) {
            //this.content = this.coreEffects.getAsyncChildDataAsObservable(this.item, this.route.snapshot.params, false);
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-playlist/playlist-row/playlist-row.component.ts